import { gql } from '@/apollo/gql';

export const groupSettingsFragment = gql(`
  fragment GroupSettingsFragment on Group {
    rowId
    id
    createdAt
    updatedAt
    label
    name
    avatar
    workflow {
      rowId
      name
    }
    members {
      totalCount
      nodes {
        ...GroupMemberFragment
      }
    }
  }
`);

export const groupMemberFragment = gql(`
fragment GroupMemberFragment on GroupMember {
    accountId
    reader
    admin
    account {
      rowId
      id
      entity {
        ... on Account_User {
          ...UserFragment
        }
        ... on Account_Bot {
          rowId
          name
          avatar
        }
        ... on Account_Team {
          rowId
          name
          avatar
          accountId
          members {
            nodes {
              userId
              user {
                ...UserFragment
              }
            }
          }
          bots {
            nodes {
              rowId
              name
              avatar
            }
          }
        }
        ... on Account_Organization {
          rowId
          name
          avatar
          accountId
          members {
            nodes {
              userId
              user {
                ...UserFragment
              }
            }
          }
          bots {
            nodes {
              rowId
              name
              avatar
            }
          }
        }
      }
    }
  }
`);

export const userFragment = gql(`
   fragment UserFragment on Account_User {
    rowId
    name
    avatar
    email
    pending
    inviteExpired
  }
`);

export const GROUP_SETTINGS_QUERY = gql(`
  query groupSettingsQuery($groupRowId: BigInt!) {
    groupByRowId(rowId: $groupRowId) {
      ...GroupSettingsFragment
    }
  }
`);

export const UPDATE_GROUP_MUTATION = gql(`
  mutation updateGroupMutation($groupRowId: BigInt!, $patch: GroupPatch!) {
    updateGroupByRowId(input: { rowId: $groupRowId, patch: $patch }) {
      group {
        rowId
        name
        avatar
      }
    }
  }
`);

export const ADD_USERS_MUTATION = gql(`
  mutation addUsersMutation($groupRowId: BigInt!, $emails: [String]!) {
    inviteUsersToGroup(input: { groupRowId: $groupRowId, emails: $emails }) {
      group {
        ...GroupSettingsFragment
      }
    }
  }
`);

export const UPDATE_GROUP_MEMBERS_MUTATION = gql(`
  mutation updateGroupMembersMutation(
    $groupId: BigInt
    $members: [UpdateGroupMemberActionInput]
  ) {
    updateGroupMembers(input: { groupId: $groupId, members: $members }) {
      group {
        ...GroupSettingsFragment
      }
    }
  }
`);
